export default __webpack_public_path__ + "static/media/bg-06.afad5d1f.png";